// LIVE-VIDEO-MANAGEMENT-1 · 판매자 소개영상 상태 문구 (서버 status·playable 기준).
export const videoManageLabel = (v) => {
  const st = v?.video?.status ?? null;
  const cur = v?.playable?.version;
  const keep = cur ? ` · v${cur} 계속 사용 중` : '';
  if (v?.cancelled) return { tone: 'gray', text: '취소된 구간' };
  if (st === 'READY') return { tone: 'green', text: '영상 준비됨' };
  if (st === 'STALE') return { tone: 'amber', text: `구간 수정됨 · 새 버전 생성 필요${keep}` };
  if (st === 'PROCESSING') return { tone: 'amber', text: cur ? `수정본 생성 중${keep}` : '영상 생성 중' };
  if (st === 'FAILED') {
    const retry = Number(v?.video?.attempts || 0) < 3 ? '재시도 가능' : '재시도 한도 초과';
    return { tone: 'red', text: `생성 실패 · ${retry}${keep}` };
  }
  if (st === 'HELD') return { tone: 'amber', text: `처리 보류${keep}` };
  return { tone: 'gray', text: '생성 대기' };
};

export const fmtClock = (sec) => {
  if (sec === null || sec === undefined || Number.isNaN(Number(sec))) return '-';
  const s = Math.max(0, Number(sec));
  return `${Math.floor(s / 60)}:${(s % 60).toFixed(1).padStart(4, '0')}`;
};

// 저장된 구간(effective)을 재생 버전 기준 초로 환산 · 시간축 불명이면 전체 범위.
export const savedTrim = (v) => {
  const dur = Number(v?.playable?.duration_sec || 0);
  const c0 = Date.parse(v?.playable?.clip_started_at || '');
  const s = Date.parse(v?.started_at || ''); const e = Date.parse(v?.ended_at || '');
  if (![c0, s, e].every(Number.isFinite)) return { start: 0, end: dur };
  const r = (x) => Math.round(Math.min(dur, Math.max(0, (x - c0) / 1000)) * 1000) / 1000;
  return { start: r(s), end: r(e) };
};

export const trimCheck = (start, end, duration, minSec = 1) => {
  const a = Number(start); const b = Number(end); const d = Number(duration);
  if (!Number.isFinite(a) || !Number.isFinite(b)) return '시작·종료 위치를 입력해 주세요.';
  if (a < 0 || b > d + 0.05) return '원본 영상 범위 안에서만 선택할 수 있습니다.';
  if (b <= a) return '종료 위치는 시작 위치보다 뒤여야 합니다.';
  if (b - a < minSec) return `최소 ${minSec}초 이상 선택해 주세요.`;
  if (a < 0.05 && b > d - 0.05) return '변경된 구간이 없습니다.';
  return null;
};
